import { Link } from 'react-router-dom';
import { Mascot } from '../components/Mascot.js';

/** The deliberate destination for retired links such as the former `/arena`. */
export function NotFound() {
  return <div className="empty" data-testid="not-found"><Mascot context="not-found" /><p>That page flew the coop.</p><Link className="btn btn--primary" to="/">Back to the gallery</Link></div>;
}
